export default __webpack_public_path__ + "static/media/022-bull market.cf81b30f.svg";